import React from "react";
import Tr from "./Tr"; // Importing the row component

// Table component to display data in a tabular format
export default function Table({
  data, // Array of data to be displayed in the table
  onEdit, // Function to handle editing a row
  onDelete, // Function to handle deleting a row
  isAllowedToEditOrDelete, // Boolean to determine if edit/delete options should be shown
}) {
  return (
    <>
      <div className="row justify-content-md-center">
        <div className="col-sm-10">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Name</th> {/* Column header for the name */}
                <th scope="col">Options</th> {/* Column header for options (edit/delete) */}
              </tr>
            </thead>

            <tbody>
              {/* Check if there is any data to display */}
              {data.length === 0 ? (
                <tr>
                  <td colSpan={2}>No data found....</td> {/* Message displayed when no data is present */}
                </tr>
              ) : (
                // Map through the data array to create table rows
                data.map((d, index) => (
                  <Tr
                    key={index} // Unique key for each row
                    id={d.layer_class_id} // ID for the row
                    layer_class_name={d.layer_class_name} // Name to be displayed
                    onEdit={onEdit} // Pass down the edit handler
                    onDelete={onDelete} // Pass down the delete handler
                    isAllowedToEditOrDelete={isAllowedToEditOrDelete} // Determine if edit/delete options are allowed
                  />
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
